module.exports = __webpack_public_path__ + "img/nz.3241e927.svg";